import {
  ROUTER_SCREENING,
  ROUTER_HOME,
  ROUTER_ROOT,
  ROUTER_COMPANY_DETAIL_PREFIX,
  ROUTER_COMPANY_DETAIL,
  ROUTER_WATCHLIST,
  ROUTER_WATCHLIST_DETAIL,
  ROUTER_QUESTIONAIRE,
  ROUTER_QUESTIONAIRE_DETAIL,
  ROUTER_STATISTICS_SCREEN,
  ROUTER_STATISTICS_REPORT,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT,
  ROUTER_CARBON_EMISSION_ACCOUNT,
  ROUTER_CARBON_ACCOUNT_DETAIL_INSTITUTION,
  ROUTER_CARBON_REDUCTION_ACCOUNT,
  ROUTER_PROJECT_LIBRARY,
  ROUTER_PROJECT_LIBRARY_DETAIL,
  ROUTER_ENV_INFORMATION_DISCLOSURE,
  ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL_ID,
  ROUTER_CREATE_PROJECT,
  ROUTER_IDENTIFY_PROJECT_COMPANY_DETAIL,
  ROUTER_IDENTIFY_PROJECT_COMPANY,
  ROUTER_CORPORATE,
  ROUTER_RISK_SURVEY,
  ROUTER_RISK_SURVEY_SUCCESS,
  ROUTE_ERROR_403,
  ROUTER_CHANGEPASSWORD,
  ROUTER_COMPANY_LIST,
  ROUTER_COMPANYS_DETAIL,
  ROUTER_COMPANY_DETAIL_PDF,
  ROUTER_COMPANY_SUCCESS,
  ROUTER_RISK_TRACKING_LIST,
  ROUTER_RISK_TRACKING_DETAIL,
  ROUTER_RISK_TRACKING_DETAIL_COMPANY_PREFIX,
  ROUTER_RISK_TRACKING_LIST_COMPANY,
  ROUTER_RISK_TRACKING_LIST_STANDARD,
  ROUTER_RISK_TRACKING,
  ROUTER_DATA_COLLECTION_PLATFORM_TYPE,
  ROUTER_DATA_COLLECTION_PLATFORM,
  ROUTER_DATA_COLLECTION_PLATFORM_LISTED_COMPANY,
  ROUTER_DATA_COLLECTION_PLATFORM_LISTED_COMPANY_DETAIL,
  ROUTER_DATA_COLLECTION_PLATFORM_QUESTIONNAIRE,
} from 'constants/router';
import React, { lazy, Suspense, useCallback, useLayoutEffect, useMemo } from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import { Location } from 'history';
import { SentryRoute as Route, Spin } from '@miotech/shared';
import MainLayout from 'layouts/main';
import useRedux from 'hooks/useRedux';
import PrivateRoute from 'components/authority-router';

const RootPage = lazy(() => import('./pages/root'));
const HomePage = lazy(() => import('./pages/home'));
// const SurveyPage = lazy(() => import('./pages/survey/Survey'));
const QuestionaireList = lazy(() => import('./pages/questionaire/list'));
const QuestionaireDetail = lazy(() => import('./pages/questionaire/detail/index'));

const ScreeningPage = lazy(() => import('./pages/screening'));
const CompanyDetailPage = lazy(() => import('./pages/company-detail'));

const GhostPDF = lazy(() => import('./pages/pdf'));
const WatchList = lazy(() => import('./pages/watch/list'));
const WatchDetails = lazy(() => import('./pages/watch/details'));

// 绿色金融业务统计
const StatisticsScreenPage = lazy(() => import('./pages/statistics/screen'));
const StatisticsReportPage = lazy(() => import('./pages/statistics/report'));

// 碳核算管理
const CarbonAccountManagementPage = lazy(() => import('./pages/carbon-account-management'));

// 碳排放核算填报
const CarbonEmissionAccountPage = lazy(() => import('./pages/carbon-emission-account'));

// 机构碳核算详情
const CarbonAccountDetailInstitutionPage = lazy(() => import('./pages/carbon-account-detail/institution'));

// 碳减排核算页面
const CarbonReductionAccountPage = lazy(() => import('./pages/carbon-reduction-account'));

// 项目库
const ProjectLibraryPage = lazy(() => import('./pages/project-library'));
const ProjectLibraryDetailPage = lazy(() => import('./pages/project-library/details'));

// 环批报告
const EnvironmentalInformationDisclosure = lazy(() => import('./pages/environmental-information-disclosure/list'));
const EnvironmentalInformationDisclosureDetail = lazy(() =>
  import('./pages/environmental-information-disclosure/detail'),
);

// 对公信贷业务管理
const CorporateList = lazy(() => import('./pages/corporate'));

// 创建项目
const CreateProject = lazy(() => import('./pages/create-corporate-project'));
const PageDetailPage = lazy(() => import('./pages/project-detail'));

// 风险调查
const RiskSurvey = lazy(() => import('./pages/risk-survey'));
const RiskSurveySuccess = lazy(() => import('./pages/risk-survey/success'));

// 授信客户列表
const BorrowerList = lazy(() => import('./pages/borrower/list'));
const BorrowerDetails = lazy(() => import('./pages/borrower/details'));
const BorrowerDetailsPDF = lazy(() => import('./pages/borrower/pdf'));
const BorrowerSuccessfully = lazy(() => import('./pages/borrower/successfully'));

// 403

// risk tracking
const RiskTrackingCompanyList = lazy(() => import('./pages/risk-tracking/list/company'));
const RiskTrackingStandardList = lazy(() => import('./pages/risk-tracking/list/standard'));
const RiskTrackingDetail = lazy(() => import('./pages/risk-tracking/detail'));

// data collection platform
const DataCollectionPlatformSME = lazy(() => import('./pages/data-collection-platform/list'));
const DataCollectionPlatformCompany = lazy(() => import('./pages/data-collection-platform/list/listed/company'));
const DataCollectionPlatformQuestionnaire = lazy(() => import('./pages/data-collection-platform/detail'));
// 403
const Error403 = lazy(() => import('./pages/error-403'));
const ChangePassword = lazy(() => import('./pages/change-password'));
interface LocationState {
  background: Location;
}

const ESGRISKDD = '/esg-risk-dd';

const mainLayoutRouters = [
  ROUTER_ROOT,
  ROUTER_HOME,
  ROUTER_SCREENING,
  ROUTER_WATCHLIST,
  ROUTER_WATCHLIST_DETAIL,
  ROUTER_COMPANY_DETAIL_PREFIX,
  ESGRISKDD,
  ROUTER_QUESTIONAIRE,
  ROUTER_QUESTIONAIRE_DETAIL,
  ROUTER_STATISTICS_SCREEN,
  ROUTER_STATISTICS_REPORT,
  ROUTER_CARBON_ACCOUNT_MANAGEMENT,
  ROUTER_CARBON_EMISSION_ACCOUNT,
  ROUTER_CARBON_ACCOUNT_DETAIL_INSTITUTION,
  ROUTER_CARBON_REDUCTION_ACCOUNT,
  ROUTER_PROJECT_LIBRARY,
  ROUTER_ENV_INFORMATION_DISCLOSURE,
  ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL_ID,
  ROUTER_CORPORATE,
  ROUTER_CREATE_PROJECT,
  ROUTER_IDENTIFY_PROJECT_COMPANY,
  ROUTER_IDENTIFY_PROJECT_COMPANY_DETAIL,
  ROUTER_RISK_SURVEY,
  ROUTER_RISK_SURVEY_SUCCESS,
  ROUTER_COMPANY_LIST,
  ROUTER_COMPANYS_DETAIL,
  ROUTER_COMPANY_DETAIL_PDF,
  ROUTE_ERROR_403,
  ROUTER_CHANGEPASSWORD,
  ROUTER_RISK_TRACKING_LIST,
  ROUTER_RISK_TRACKING_DETAIL,
  ROUTER_COMPANY_SUCCESS,
  ROUTER_RISK_TRACKING_LIST_COMPANY,
  ROUTER_RISK_TRACKING_LIST_STANDARD,
  ROUTER_RISK_TRACKING_DETAIL_COMPANY_PREFIX,
  ROUTER_DATA_COLLECTION_PLATFORM,
  ROUTER_DATA_COLLECTION_PLATFORM_LISTED_COMPANY,
  ROUTER_DATA_COLLECTION_PLATFORM_LISTED_COMPANY_DETAIL,
  ROUTER_DATA_COLLECTION_PLATFORM_QUESTIONNAIRE,
];

const Container: React.FC = () => {
  const location = useLocation<LocationState>();
  const { dispatch } = useRedux(s => s.greenLevel);
  const {
    selector: { resourceList },
  } = useRedux(s => s.userRole);
  const fetchUserPermission = useCallback(async () => {
    dispatch.quotaRemain.updateAsync();
    dispatch.greenLevel.updateAsync();
  }, [dispatch.greenLevel, dispatch.quotaRemain]);
  useLayoutEffect(() => {
    fetchUserPermission();
  }, [fetchUserPermission]);
  // 判断是否是 HSBC 用户
  const isHSBC = useMemo(() => resourceList?.find((item: any) => item.routePath === ROUTER_COMPANY_LIST)?.selected, [
    resourceList,
  ]);
  // 判断是否是 HABC 用户
  const isHABC = useMemo(() => resourceList?.find((item: any) => item.routePath === ROUTER_RISK_TRACKING)?.selected, [
    resourceList,
  ]);
  const memoRoute = useMemo(() => {
    // 如果是 HSBC 用户，则重定向到 borrower-list 页面
    if (isHSBC && ['/'].includes(location.pathname)) {
      return <Redirect to={ROUTER_COMPANY_LIST} />;
    }
    if (isHABC && ['/'].includes(location.pathname)) {
      return <Redirect to={`${ROUTER_DATA_COLLECTION_PLATFORM}/listed`} />;
    }
    return (
      <div>
        <Suspense
          fallback={
            <Spin>
              <div style={{ height: '100px' }}></div>
            </Spin>
          }
        >
          <Switch location={location}>
            <Route
              path={`(${mainLayoutRouters.join('|')})`}
              component={() => {
                return (
                  <MainLayout>
                    <Switch>
                      <Suspense
                        fallback={
                          <Spin>
                            <div style={{ height: '100px' }}></div>
                          </Spin>
                        }
                      >
                        <Route path={ROUTER_ROOT} exact component={RootPage} />
                        <PrivateRoute path={ROUTER_HOME} exact component={HomePage} />
                        <PrivateRoute path={ROUTER_COMPANY_DETAIL} component={CompanyDetailPage} />
                        <PrivateRoute path={ROUTER_SCREENING} exact component={ScreeningPage} />
                        <PrivateRoute path={ROUTER_QUESTIONAIRE} exact component={QuestionaireList} />
                        <PrivateRoute path={ROUTER_QUESTIONAIRE_DETAIL} component={QuestionaireDetail} />
                        <PrivateRoute path={ROUTER_CARBON_ACCOUNT_MANAGEMENT} component={CarbonAccountManagementPage} />
                        <PrivateRoute path={ROUTER_CARBON_EMISSION_ACCOUNT} component={CarbonEmissionAccountPage} />
                        <PrivateRoute path={ROUTER_CARBON_REDUCTION_ACCOUNT} component={CarbonReductionAccountPage} />
                        <PrivateRoute
                          path={ROUTER_CARBON_ACCOUNT_DETAIL_INSTITUTION}
                          component={CarbonAccountDetailInstitutionPage}
                        />
                        <PrivateRoute path={ROUTER_PROJECT_LIBRARY} exact component={ProjectLibraryPage} />
                        <PrivateRoute path={ROUTER_PROJECT_LIBRARY_DETAIL} exact component={ProjectLibraryDetailPage} />

                        <PrivateRoute
                          path={ROUTER_ENV_INFORMATION_DISCLOSURE}
                          exact
                          component={EnvironmentalInformationDisclosure}
                        />
                        <PrivateRoute
                          path={ROUTER_ENV_INFORMATION_DISCLOSURE_DETAIL_ID}
                          exact
                          component={EnvironmentalInformationDisclosureDetail}
                        />
                        {/* 创建项目 */}
                        <PrivateRoute path={ROUTER_CORPORATE} exact component={CorporateList} />
                        <PrivateRoute path={ROUTER_CREATE_PROJECT} exact component={CreateProject} />
                        <PrivateRoute path={ROUTER_IDENTIFY_PROJECT_COMPANY_DETAIL} exact component={PageDetailPage} />
                        {/* 风险调查 */}
                        <PrivateRoute path={ROUTER_RISK_SURVEY} exact component={RiskSurvey} />
                        <PrivateRoute path={ROUTER_RISK_SURVEY_SUCCESS} exact component={RiskSurveySuccess} />
                        <PrivateRoute path={ROUTER_STATISTICS_SCREEN} exact component={StatisticsScreenPage} />
                        <PrivateRoute path={ROUTER_STATISTICS_REPORT} exact component={StatisticsReportPage} />
                        <PrivateRoute path={ROUTER_WATCHLIST} exact component={WatchList} />
                        <PrivateRoute path={ROUTER_WATCHLIST_DETAIL} exact component={WatchDetails} />
                        {/* risk tracking */}
                        <PrivateRoute
                          path={ROUTER_RISK_TRACKING_LIST_COMPANY}
                          exact
                          component={RiskTrackingCompanyList}
                        />
                        <PrivateRoute
                          path={ROUTER_RISK_TRACKING_LIST_STANDARD}
                          exact
                          component={RiskTrackingStandardList}
                        />
                        <PrivateRoute path={ROUTER_RISK_TRACKING_DETAIL} exact component={RiskTrackingDetail} />
                        <PrivateRoute path={ROUTER_COMPANY_LIST} exact component={BorrowerList} />
                        <PrivateRoute path={ROUTER_COMPANYS_DETAIL} exact component={BorrowerDetails} />
                        <PrivateRoute path={ROUTER_COMPANY_SUCCESS} exact component={BorrowerSuccessfully} />
                        {/* data collection platform */}
                        <PrivateRoute path={ROUTER_DATA_COLLECTION_PLATFORM_TYPE} exact component={DataCollectionPlatformSME} />
                        <PrivateRoute path={ROUTER_DATA_COLLECTION_PLATFORM_LISTED_COMPANY_DETAIL} exact component={DataCollectionPlatformCompany} />
                        <PrivateRoute path={ROUTER_DATA_COLLECTION_PLATFORM_QUESTIONNAIRE} exact component={DataCollectionPlatformQuestionnaire} />
                        <Route path={ROUTE_ERROR_403} exact component={Error403} />
                        <Route path={ROUTER_CHANGEPASSWORD} exact component={ChangePassword} />
                      </Suspense>
                    </Switch>
                  </MainLayout>
                );
              }}
            />
            <Route path="/ghost-pdf/:id" component={GhostPDF} />
            <Route path="/company-pdf/:id" component={BorrowerDetailsPDF} />
          </Switch>
        </Suspense>
      </div>
    );
  }, [isHSBC, location, isHABC]);
  return memoRoute;
};

export default Container;
